'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {
  "BulkActionsOuterLayout": "Polaris-BulkActions__BulkActionsOuterLayout",
  "BulkActionsSelectAllWrapper": "Polaris-BulkActions__BulkActionsSelectAllWrapper",
  "BulkActionsPromotedActionsWrapper": "Polaris-BulkActions__BulkActionsPromotedActionsWrapper",
  "BulkActionsLayout": "Polaris-BulkActions__BulkActionsLayout",
  "BulkActionsLayout--measuring": "Polaris-BulkActions--bulkActionsLayoutMeasuring",
  "BulkActionsMeasurerLayout": "Polaris-BulkActions__BulkActionsMeasurerLayout",
  "BulkActionButton": "Polaris-BulkActions__BulkActionButton",
  "disabled": "Polaris-BulkActions--disabled",
  "AllAction": "Polaris-BulkActions__AllAction"
};

exports.default = styles;
